<template>
  <b-container fluid>
    <backlink/>
    <h1>
      <div class="indicator">
        {{ items.length}}
        <i class="far fa-truck fa-xs"></i>
      </div>Expéditions en attente
    </h1>

    <div class="table-wrapper">
      <b-table ref="table" hover show-empty :fields="fields" :items="items" :busy="isBusy">
        <template slot="table-busy">
          <div class="text-center my-2">
            <div v-if="isBusy" class="loader"></div>Les données sont en cours de chargement...
          </div>
        </template>
        <template slot="empty" slot-scope="scope">
          <div class="text-center mt-2">Cette liste est vide pour le moment</div>
        </template>

        <template slot="shipping_number" slot-scope="data">
          <router-link
            v-if="$store.getters['auth/isAuthorized']('shipping_edit')"
            :to="{name: 'ShippingMobileEdit', params: {id: data.item.id}}"
          >{{ data.value }}</router-link>
          <template v-else>{{ data.value }}</template>
        </template>
        <template slot="status.name" slot-scope="data">
          <b-badge variant="primary">{{ data.value }}</b-badge>
        </template>
      </b-table>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "ShippingMobileList",
  data() {
    return {
      fields: [
        {
          key: "shipping_number",
          label: "Code interne"
        },
        {
          key: "geo_area",
          label: "Zone géographique"
        },
        {
          key: "status.name",
          label: "Statut"
        }
      ],
      isBusy: false
    };
  },
  computed: {
    // On lie 'items' au données du store (sauf si des données sont passées du parent)
    items: function() {
      return this.$store.getters["shipping/getByStatusSlug"]([
        "shipping-en-preparation",
        "shipping-en-attente-de-solution-de-transport"
      ]);
    }
  },
  mounted() {
    // On demande au store de se mettre à jour à partir de l'API
    this.$store
      .dispatch("shipping/getByStatusSlug", [
        "shipping-en-preparation",
        "shipping-en-attente-de-solution-de-transport"
      ])
      .then(() => (this.isBusy = false));

    // Si il n'y a pas déjà des items dans le store, on affiche le loader le temps que le store se mette à jour
    if (!this.items || !this.items.length) {
      this.isBusy = true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ShippingMobile/ShippingMobileList.vue